import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for PWA. We listen for `updatefound` + `waiting`
// so that when a new SW version is deployed, `PWAStatus` (mounted in the
// dashboard layout) can show a "Güncelle" toast that, on click, posts
// `SKIP_WAITING` to swap the version and reloads.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);

        // Helper: a worker moved into the "installed" state while another
        // worker is already controlling the page → update is waiting.
        const notifyUpdate = (sw) => {
          try {
            window.dispatchEvent(new CustomEvent('pwa-update-ready', {
              detail: { registration, waiting: sw },
            }));
          } catch { /* noop */ }
        };

        if (registration.waiting && navigator.serviceWorker.controller) {
          notifyUpdate(registration.waiting);
        }
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              notifyUpdate(installing);
            }
          });
        });

        // Once the new SW takes control (user clicked "Güncelle"), reload.
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });

        // Poll for updates every 30 min — catches cases where the user
        // keeps a tab open for days without a hard reload.
        setInterval(() => { registration.update().catch(() => {}); }, 30 * 60 * 1000);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
